import { Menu, Transition } from "@headlessui/react";
import { NavLink, useNavigate } from "react-router-dom";
import { Fragment } from "react";
import { PageRoutes } from "@/enums/routes.enum";
import env from "@/utils/env";
import { useAuth } from "@/hooks/auth";
import { classNames } from "@/utils";

const userNavigation = [
    { name: "Your Profile", href: "/user-profile" },
    { name: "Sign out" },
];
const ProfileDropdown = () => {
    const {signout, user: { name }, profileImage } = useAuth();
    const navigate = useNavigate();

    return (
        <Menu as="div" className="mx-3 relative">
            <div className="flex justify-center items-center gap-x-2">
                <div className="">
                    <h1 className="font-medium text-gray-600">{name}</h1>
                </div>
                <Menu.Button className="max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500">
                    <span className="sr-only">Open user menu</span>
                    {profileImage ? (
                        <img
                            className="h-8 w-8 rounded-full object-cover"
                            src={`${env.storageUrl}/storage/${profileImage}`}
                            alt={name}
                        />
                    ) : (
                        <div className="h-8 w-8 rounded-full bg-primary-500 flex items-center justify-center text-white text-sm font-semibold">
                            {name?.charAt(0)?.toUpperCase() || 'U'}
                        </div>
                    )}
                </Menu.Button>
            </div>
            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                    {userNavigation.map((item) => (
                        <Menu.Item key={item.name}>
                            {({ active }: { active: boolean }) => (
                                <>
                                    {item.href ? (
                                        <NavLink
                                            to={item.href}
                                            onClick={
                                                item.href === PageRoutes.LOGOUT
                                                    ? () =>
                                                        signout(() => {
                                                            navigate("/", { replace: true });
                                                        })
                                                    : () => { }
                                            }
                                            className={classNames(
                                                active ? "bg-gray-100" : "",
                                                "hover:cursor-pointer block px-4 py-2 text-sm hover:text-white hover:bg-blue-500 hover:rounded-t-md hover:font-semibold"
                                            )}
                                        >
                                            {item.name}
                                        </NavLink>
                                    ) : (
                                        <div
                                            onClick={() =>
                                                signout(() => {
                                                    navigate("/", { replace: true });
                                                })
                                            }
                                            className={
                                                "hover:cursor-pointer justify-start px-4 py-2 text-sm hover:text-white hover:bg-blue-500 hover:rounded-b-md hover:font-semibold"
                                            }
                                        >
                                            {item.name}
                                        </div>
                                    )}
                                </>
                            )}
                        </Menu.Item>
                    ))}
                </Menu.Items>
            </Transition>
        </Menu>
    )
}

export default ProfileDropdown;
